import { createContext } from 'react';

/**
 * When the CV preview is inside a scaled container (e.g. mobile option A),
 * getBoundingClientRect returns scaled dimensions. This scale is used to convert
 * measurements back to logical pixels so usePageDelimitation layout matches the PDF.
 */
export const PageDelimitationScaleContext = createContext<number>(1);

/**
 * When set (e.g. narrow viewport with spacer), height of content without the last-page spacer.
 * PageDelimiter uses this to only draw lines between full pages of content,
 * avoiding a line before an "empty" spacer-only page.
 */
export const PageDelimiterContentHeightContext = createContext<number | null>(null);
